import React, { useState } from "react";
import ReactPlayer from "react-player";

import "./WatchVideo.scss";
import { AiOutlineStar } from "react-icons/ai";
import { TfiDownload } from "react-icons/tfi";
import { BsBookmark, BsFlag } from "react-icons/bs";
import { CgArrowRightR } from "react-icons/cg";
import QbankCard from "../Qbank/QbankCard";
import VideoCard from "./VideoCard";

const tabOption = {
  upNext: "upnext",
  relatedQbank: "relatedQbank",
};

export default function WatchVideo() {
  const [suggestedTab, setSuggestedTab] = useState(tabOption.relatedQbank);

  const [suggestedVideos, setSuggestedVideos] = useState([<VideoCard />, <VideoCard />, <VideoCard />]);
  const [suggestedQbanks, setSuggestedQbank] = useState([<QbankCard />, <QbankCard />, <QbankCard />]);

  const renderSuggestedItems = () => {
    if (suggestedTab === tabOption.relatedQbank) {
      return suggestedQbanks.map((Qbank) => {
        return Qbank;
      });
    }
  };

  const handleTabOptionClick = (e) => {
    if (e.target.id === tabOption.upNext) {
      setSuggestedTab(tabOption.upNext);
    } else if (e.target.id === tabOption.relatedQbank) {
      setSuggestedTab(tabOption.relatedQbank);
    }
  };

  const checkActiveTab = (optionName) => {
    if (optionName === tabOption.upNext) {
      return "active";
    } else if (optionName === tabOption.relatedQbank) {
      return "active";
    }
    return "";
  };

  return (
    <div className="watch_video_container">
      <div className="video_player_container">
        <ReactPlayer url={`https://www.youtube.com/watch?v=1V-jSJbzJ_4&ab_channel=LyricStudios`} height="100%" width={"100%"} />
      </div>
      <div className="video_info_container">
        <div className="video_info">
          <h3>Introduction</h3>
          <div className="video_rating_container">
            <AiOutlineStar />
            4.9
          </div>
        </div>
        <div className="download_container">
          <TfiDownload />
        </div>
      </div>
      <div className="video_utility_container">
        <div className="bookmark utility_item">
          <BsBookmark />
          <p>Bookmark</p>
        </div>
        <div className="complete utility_item">
          <CgArrowRightR />
          <p>Complete</p>
        </div>
        <div className="report utility_item">
          <BsFlag />
          <p>Report Error</p>
        </div>
      </div>
      <div className="suggestion_container">
        <div className="suggestion_header not_selectable">
          <ul onClick={handleTabOptionClick}>
            <li className="" id={tabOption.upNext}>
              Up next
            </li>
            <li className={checkActiveTab(tabOption.relatedQbank)} id={tabOption.relatedQbank}>
              Related Qbank
            </li>
          </ul>
        </div>
        <div className="suggestion_body">
          <div className="related_qbanks_container">{renderSuggestedItems()}</div>
        </div>
      </div>
    </div>
  );
}
